<template>
 <div></div>
</template>

<script>
export default {
    methods: {
        toUrl(url){
            window.open(url, '_blank');
        }
    },
}
</script>

<style scoped lang="scss">
  
</style>